import { cn } from '@coas/ui/lib';
import type { RouterOutputs } from 'trpc/shared';
import { Price } from '~/shared/ui/price';

type Props = {
    displayPrice: RouterOutputs['product']['getProductsInfinite']['products'][number]['displayPrice'];
    className?: string;
};

export default ({ displayPrice, className }: Props) => {
    const { discountPercent, originalPrice, price } = displayPrice;

    if (price === null) return null;

    const showDiscount = discountPercent !== null && originalPrice !== null;

    return (
        <span className={cn('inline-flex items-baseline gap-x-2', className)}>
            <Price>{price}</Price>
            {showDiscount && (
                <>
                    <span className='text-14 text-neutral-500 line-through'>
                        <Price>{originalPrice}</Price>
                    </span>
                    <span className='font-semibold text-14 text-red-600'>−{discountPercent}%</span>
                </>
            )}
        </span>
    );
};
